"use strict";

// https://dom.spec.whatwg.org/#interface-nonelementparentnode
// getElementById is implemented separately inside Document and DocumentFragment.
class NonElementParentNodeImpl {

}

module.exports = {
  implementation: NonElementParentNodeImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/nodes/NonElementParentNode-impl.js
// module id = 5Agu
// module chunks = 0